theme.VendorProducts = (function() {
  var maxProducts = 4;

  function VendorProducts(container) {
    if (!container) {
      return;
    }

    this.container = container;
    this.sectionId = this.container.getAttribute('data-section-id');
    this.currentProduct = this.container.getAttribute('data-product-id');

    theme.initWhenVisible({
      element: this.container,
      callback: this.init.bind(this),
      threshold: 600
    });
  };

  VendorProducts.prototype = Object.assign({}, VendorProducts.prototype, {
    init: function() {
      this.outputContainer = document.getElementById('VendorProducts-' + this.sectionId);
      this.vendor = this.container.getAttribute('data-vendor');
      var url = theme.routes.collections + '/vendors?view=vendor-ajax&q=' + this.vendor;
      // remove double `/` in case shop might have /en or language in URL
      url = url.replace('//', '/');

      fetch(url).then(function(response) {
        return response.text();
      }).then(html => {
        var count = 0;
        var products = [];
        var modals = [];
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var allProds = doc.querySelectorAll('.grid-product');
        // Do not add current product to output
        allProds.forEach(el => {
          var id = el.dataset.productId;

          if (count === maxProducts) {
            return;
          }

          if (id === this.currentProduct) {
            return;
          }

          var modal = doc.querySelector('.modal[data-product-id="'+ id +'"]');
          if (modal) {
            modals.push(modal);
          }

          count++;
          products.push(el);
        });

        this.outputContainer.innerHTML = '';

        if (products.length === 0) {
          this.container.classList.add('hide');
        } else {
          this.outputContainer.classList.remove('hide');
          this.outputContainer.append(...products);
          

          if (modals.length) {
            this.outputContainer.append(...modals);
            new theme.QuickShop(this.outputContainer);
          }

          new theme.QuickAdd(this.outputContainer);
                yotpoWidgetsContainer.initWidgets()

        }
      
      
      
      });
    }
  });

  return VendorProducts;
})();

/**
 * Ajax Renderer
 * -----------------------------------------------------------------------------
 * Render sections without reloading the page.
 * @param {Object[]} sections - The section to update on render.
 * @param {string} sections[].sectionId - The ID of the section from Shopify.
 * @param {string} sections[].nodeId - The ID of the DOM node to replace.
 * @param {Function} sections[].onReplace (optional) - The custom render function.
 * @param {boolean} debug - Output logs to console for debugging.
 *
 */

theme.AjaxRenderer = (function () {
  function AjaxRenderer({ sections, onReplace, debug } = {}) {
    this.sections = sections || [];
    this.cachedSections = [];
    this.onReplace = onReplace;
    this.debug = Boolean(debug);
  }

  AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
    renderPage: function (basePath, newParams, updateURLHash = true) {
      const currentParams = new URLSearchParams(window.location.search);
      const updatedParams = this.getUpdatedParams(currentParams, newParams)

      const sectionRenders = this.sections.map(section => {

        const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
        const cachedSectionUrl = cachedSection => cachedSection.url === url;

        return this.cachedSections.some(cachedSectionUrl)
          ? this.renderSectionFromCache(cachedSectionUrl, section)
          : this.renderSectionFromFetch(url, section);
      });

      if (updateURLHash) this.updateURLHash(updatedParams);

      return Promise.all(sectionRenders);
    },

    renderSectionFromCache: function (url, section) {
      const cachedSection = this.cachedSections.find(url);

      this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
      this.renderSection(cachedSection.html, section);
      return Promise.resolve(section);
    },

    renderSectionFromFetch: function (url, section) {
      this.log(`[AjaxRenderer] redering from fetch: url=${url}`);

      return new Promise((resolve, reject) => {
        fetch(url)
          .then(response => response.text())
          .then(responseText => {
            const html = responseText;
            this.cachedSections = [...this.cachedSections, { html, url }];
            this.renderSection(html, section);
            resolve(section);
          })
          .catch(err => reject(err));
      });
    },

    renderSection: function (html, section) {
      this.log(
        `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
      );

      const newDom = new DOMParser().parseFromString(html, 'text/html');
      if (this.onReplace) {
        this.onReplace(newDom, section);
      } else {
        if (typeof section.nodeId === 'string') {
          var newContentEl = newDom.getElementById(section.nodeId);
          if (!newContentEl) {
            return;
          }

          document.getElementById(section.nodeId).innerHTML =
            newContentEl.innerHTML;
        } else {
          section.nodeId.forEach(id => {
            document.getElementById(id).innerHTML =
              newDom.getElementById(id).innerHTML;
          });
        }
      }

      return section;
    },

    getUpdatedParams: function (currentParams, newParams) {
      const clone = new URLSearchParams(currentParams);
      const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];

      // Find what params need to be removed
      // delete happens first as we cannot specify keys based off of values
      for (const [key, value] of clone.entries()) {
        if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
          clone.delete(key);
        };
      }

      // Find what params need to be added
      for (const [key, value] of newParams.entries()) {
        if (!clone.getAll(key).includes(value) && value !== '') {
          clone.append(key, value);
        }
      }

      return clone;
    },

    updateURLHash: function (searchParams) {
      history.pushState(
        {},
        '',
        `${window.location.pathname}${
          searchParams && '?'.concat(searchParams)
        }`,
      );
      yotpoWidgetsContainer.initWidgets()

    },

    log: function (...args) {
      if (this.debug) {
        console.log(...args);
      }
    },
  });

  return AjaxRenderer;
})();

theme.PriceRange = (function () {
  var defaultStep = 10;
  var selectors = {
    priceRange: '.price-range',
    priceRangeSlider: '.price-range__slider',
    priceRangeInputMin: '.price-range__input-min',
    priceRangeInputMax: '.price-range__input-max',
    priceRangeDisplayMin: '.price-range__display-min',
    priceRangeDisplayMax: '.price-range__display-max',
  };

  function PriceRange(container, {onChange, onUpdate, ...sliderOptions} = {}) {
    this.container = container;
    this.onChange = onChange;
    this.onUpdate = onUpdate;
    this.sliderOptions = sliderOptions || {};

    return this.init();
  }

  PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
    init: function () {
      if (!this.container.classList.contains('price-range')) {
        throw new Error('You must instantiate PriceRange with a valid container')
      }

      this.formEl = this.container.closest('form');
      this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
      this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
      this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
      this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
      this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);

      this.minRange = parseFloat(this.container.dataset.min) || 0;
      this.minValue = parseFloat(this.container.dataset.minValue) || 0;
      this.maxRange = parseFloat(this.container.dataset.max) || 100;
      this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;

      return this.createPriceRange();
    },

    createPriceRange: function () {
      if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
        this.sliderEl.noUiSlider.destroy();
      }

      var slider = noUiSlider.create(this.sliderEl, {
        connect: true,
        step: defaultStep,
        ...this.sliderOptions,
        // Do not allow overriding these options
        start: [this.minValue, this.maxValue],
        range: {
          min: this.minRange,
          max: this.maxRange,
        },
      });

      slider.on('update', values => {
        this.displayMinEl.innerHTML = theme.Currency.formatMoney(
          values[0],
          theme.settings.moneyFormat,
        );
        this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
          values[1],
          theme.settings.moneyFormat,
        );

        if (this.onUpdate) {
          this.onUpdate(values);
        }
      });

      slider.on('change', values => {
        this.inputMinEl.value = values[0];
        this.inputMaxEl.value = values[1];

        if (this.onChange) {
          const formData = new FormData(this.formEl);
          this.onChange(formData);
        }
      });

      return slider;
    },
  });

  return PriceRange;
})();

theme.CollectionHeader = (function() {
  var hasLoadedBefore = false;

  function CollectionHeader(container) {
    this.namespace = '.collection-header';

    var heroImageContainer = container.querySelector('.collection-hero');
    if (heroImageContainer) {
      if (hasLoadedBefore) {
        this.checkIfNeedReload();
      }
      theme.loadImageSection(heroImageContainer);
    } else if (theme.settings.overlayHeader) {
      theme.headerNav.disableOverlayHeader();
    }

    hasLoadedBefore = true;
  }

  CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
    // A liquid variable in the header needs a full page refresh
    // if the collection header hero image setting is enabled
    // and the header is set to sticky. Only necessary in the editor.
    checkIfNeedReload: function() {
      if (!Shopify.designMode) {
        return;
      }

      if (theme.settings.overlayHeader) {
        var header = document.querySelector('.header-wrapper');
        if (!header.classList.contains('header-wrapper--overlay')) {
          location.reload();
        }
      }
    }
  });

  return CollectionHeader;
})();

theme.CollectionSidebar = (function() {
  var selectors = {
    sidebarId: 'CollectionSidebar',
    trigger: '.collection-filter__btn',
    mobileWrapper: '#CollectionInlineFilterWrap',
    filters: '.filter-wrapper',
    filterBar: '.collection-filter'
  };

  var config = {
    isOpen: false,
    namespace: '.collection-filters'
  }

  function CollectionSidebar() {
    // Do not load when no sidebar exists
    if(!document.getElementById(selectors.sidebarId)) {
      return;
    }

    document.addEventListener('filter:selected', this.close.bind(this));
    this.init();
  }

  function getScrollFilterTop() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var elTop = document.querySelector(selectors.filterBar).getBoundingClientRect().top;
    return elTop + scrollTop;
  }

  // Set a max-height on drawers when they're opened via CSS variable
  // to account for changing mobile window heights
  function sizeDrawer() {
    var header = document.getElementById('HeaderWrapper').offsetHeight;
    var filters = document.querySelector(selectors.filterBar).offsetHeight;
    var max = window.innerHeight - header - filters;
    document.documentElement.style.setProperty('--maxFiltersHeight', `${max}px`);
  }

  CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
    init: function() {
      config.isOpen = false;
      theme.a11y.unlockMobileScrolling(config.namespace);

      // This function runs on page load, and when the collection section loads
      // so we need to be mindful of not duplicating event listeners
      this.container = document.getElementById(selectors.sidebarId);
      this.trigger = document.querySelector(selectors.trigger);
      this.wrapper = document.querySelector(selectors.mobileWrapper);
      this.filters = this.wrapper.querySelector(selectors.filters);

      this.trigger.off('click');
      this.trigger.on('click', this.toggle.bind(this));
    },

    /*============================================================================
      Open and close filter drawer
    ==============================================================================*/
    toggle: function() {
      if (config.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },

    open: function() {
      sizeDrawer();

      // Scroll to top of filter bar when opened
      var scrollTo = getScrollFilterTop();
      window.scrollTo({top: scrollTo, behavior: 'smooth'});

      this.trigger.classList.add('is-active');

      theme.utils.prepareTransition(this.filters, function() {
        this.filters.classList.add('is-active');
      }.bind(this));
      config.isOpen = true;

      theme.a11y.lockMobileScrolling(config.namespace);

      window.on('keyup' + config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
    },

    close: function() {
      this.trigger.classList.remove('is-active');

      theme.utils.prepareTransition(this.filters, function() {
        this.filters.classList.remove('is-active');
      }.bind(this));
      config.isOpen = false;

      theme.a11y.unlockMobileScrolling(config.namespace);

      window.off('keyup' + config.namespace);
    },

    onSelect: function() {
      this.open();
    },

    onDeselect: function() {
      this.close();
    }
  });

  return CollectionSidebar;
})();

/*============================================================================
  Collection JS sets up grids of products, even if not
  on the collection template.
  When on the collection template, also setup sorting, filters, grid options
==============================================================================*/
theme.Collection = (function() {
  var isAnimating = false;

  var selectors = {
    sortSelect: '#SortBy',
    sortBtn: '.filter-sort',

    colorSwatchImage: '.grid-product__color-image',
    colorSwatch: '.color-swatch--with-image',

    viewChange: '.grid-view-btn',
    productGrid: '.product-grid',

    collectionGrid: '.collection-grid__wrapper',
    sidebar: '#CollectionSidebar',
    activeTagList: '.tag-list--active-tags',
    tags: '.tag-list input',
    activeTags: '.tag-list a',
    tagsForm: '.filter-form',
    filterBar: '.collection-filter',
    priceRange: '.price-range',
    trigger: '.collapsible-trigger',

    filters: '.filter-wrapper',
    sidebarWrapper: '#CollectionSidebarFilterWrap',
    inlineWrapper: '#CollectionInlineFilterWrap',
  };

  var config = {
    mobileFiltersInPlace: false
  };

  var classes = {
    activeTag: 'tag--active',
    removeTagParent: 'tag--remove',
    collapsibleContent: 'collapsible-content',
    isOpen: 'is-open',
  };

  function Collection(container) {
    this.container = container;
    this.containerId = container.id;
    this.sectionId = container.getAttribute('data-section-id');
    this.namespace = '.collection-' + this.sectionId;
    this.isCollectionTemplate = this.container.dataset.collectionTemplate;
    this.ajaxRenderer = new theme.AjaxRenderer({
      sections: [{ sectionId: this.sectionId, nodeId: 'CollectionAjaxContent' }],
      onReplace: this.onReplaceAjaxContent.bind(this),
    });

    this.init(container);
  }

  Collection.prototype = Object.assign({}, Collection.prototype, {
    init: function(container) {
      config.mobileFiltersInPlace = false;

      // If container not set, section has been reinitialized.
      // Update this.container to refreshed DOM element
      if (!container) {
        this.container = document.getElementById(this.containerId);
      }

      if (this.isCollectionTemplate) {
        this.cloneFiltersOnMobile();
        this.initSort();
        this.initFilters();
        this.initPriceRange();
        this.initGridOptions();

        // Has to init after the Collection JS because cloneFiltersOnMobile
        this.sidebar = new theme.CollectionSidebar();
      }

      this.quickAdd = new theme.QuickAdd(this.container);
      this.quickShop = new theme.QuickShop(this.container);

      this.colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
      if (this.colorImages.length) {
        this.swatches = this.container.querySelectorAll(selectors.colorSwatch);
        this.colorSwatchHovering();
      }
    },

    /*============================================================================
      Collection sorting
    ==============================================================================*/
    initSort: function() {
      this.queryParams = new URLSearchParams(window.location.search);
      this.sortSelect = document.querySelector(selectors.sortSelect);
      this.sortBtns = document.querySelectorAll(selectors.sortBtn);

      if (this.sortSelect) {
        this.defaultSort = this.getDefaultSortValue();
        this.sortSelect.on('change' + this.namespace, () => { this.onSortChange() });
      }

      if (this.sortBtns.length) {
        this.sortBtns.forEach(btn => {
          btn.addEventListener('click', function() {
            document.dispatchEvent(new Event('filter:selected'));
            const sortValue = btn.dataset.value;
            this.onSortChange(sortValue);
          }.bind(this));
        });
      }
    },

    getSortValue: function() {
      return this.sortSelect.value || this.defaultSort;
    },

    getDefaultSortValue: function() {
      return this.sortSelect.getAttribute('data-default-sortby');
    },

    onSortChange: function(sortValue = null) {
      this.queryParams = new URLSearchParams(window.location.search);

      if (sortValue) {
        this.queryParams.set('sort_by', sortValue);
      } else {
        this.queryParams.set('sort_by', this.getSortValue());
      }

      this.queryParams.delete('page'); // Delete if it exists
      window.location.search = this.queryParams.toString();
    },

    /*============================================================================
      Color swatch hovering
    ==============================================================================*/
    colorSwatchHovering: function() {
      this.swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this.setActiveColorImage(swatch);
        }.bind(this));

        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this.setActiveColorImage(swatch);
        }.bind(this), {passive: true});
      });
    },

    setActiveColorImage: function(swatch) {
      var id = swatch.dataset.variantId;
      var image = swatch.dataset.variantImage;

      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });

      // Unset all active swatches
      this.swatches.forEach(el => {
        el.classList.remove('is-active');
      });

      // Set active image and swatch
      var imageEl = this.container.querySelector('.grid-product__color-image--' + id);
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');

      // Update product grid item href with variant URL
      var variantUrl = swatch.dataset.url;
      var gridItem = swatch.closest('.grid-item__link');
      gridItem.setAttribute('href', variantUrl);
    },

    /*============================================================================
      Grid view options
    ==============================================================================*/
    initGridOptions: function() {
      var grid = this.container.querySelector(selectors.productGrid);
      var viewBtns = this.container.querySelectorAll(selectors.viewChange);
      this.container.querySelectorAll(selectors.viewChange).forEach(btn => {
        btn.addEventListener('click', function() {
          viewBtns.forEach(el=>{
            el.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          var newView = btn.dataset.view;
          grid.dataset.view = newView;

          // Set as cart attribute so we can access in liquid
          theme.cart.updateAttribute('product_view', newView);

          // Trigger resize to update layzloaded images
          window.dispatchEvent(new Event('resize'));
        });
      });
    },

    /*====================
      Collection filters
    ====================*/
    initFilters: function() {
      var filterBar = document.querySelectorAll(selectors.filterBar);

      if (!filterBar.length) {
        return;
      }

      document.addEventListener('matchSmall', this.cloneFiltersOnMobile.bind(this));
      this.bindBackButton();

      // Set mobile top value for filters if sticky header enabled
      if (theme.config.stickyHeader) {
        this.setFilterStickyPosition();

        document.addEventListener('headerStickyChange', theme.utils.debounce(500, this.setFilterStickyPosition));
        window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
      }

      document.querySelectorAll(selectors.activeTags).forEach(tag => {
        tag.addEventListener('click', this.onTagClick.bind(this));
      });

      document.querySelectorAll(selectors.tagsForm).forEach(form => {
        form.addEventListener('input', this.onFormSubmit.bind(this));
      });
    },

    initPriceRange: function() {
      const priceRangeEls = document.querySelectorAll(selectors.priceRange)
      priceRangeEls.forEach((el) => new theme.PriceRange(el, {
        // onChange passes in formData
        onChange: this.renderFromFormData.bind(this),
      }));
    },

    cloneFiltersOnMobile: function() {
      if (config.mobileFiltersInPlace) {
        return;
      }

      var sidebarWrapper = document.querySelector(selectors.sidebarWrapper);
      if (!sidebarWrapper) {
        return;
      }
      var filters = sidebarWrapper.querySelector(selectors.filters).cloneNode(true);

      var inlineWrapper = document.querySelector(selectors.inlineWrapper);

      inlineWrapper.innerHTML = '';
      inlineWrapper.append(filters);

      // Update collapsible JS
      theme.collapsibles.init(inlineWrapper);

      config.mobileFiltersInPlace = true;
    },

    renderActiveTag: function(parent, el) {
      const textEl = parent.querySelector('.tag__text');

      if (parent.classList.contains(classes.activeTag)) {
        parent.classList.remove(classes.activeTag);
      } else {
        parent.classList.add(classes.activeTag);

        // If adding a tag, show new tag right away.
        // Otherwise, remove it before ajax finishes
        if (el.closest('li').classList.contains(classes.removeTagParent)) {
          parent.remove();
        } else {
          // Append new tag in both drawer and sidebar
          document.querySelectorAll(selectors.activeTagList).forEach(list => {
            const newTag = document.createElement('li');
            const newTagLink = document.createElement('a');
            newTag.classList.add('tag', 'tag--remove');
            newTagLink.classList.add('btn', 'btn--small');
            newTagLink.innerText = textEl.innerText;
            newTag.appendChild(newTagLink);

            list.appendChild(newTag);
          });
        }
      }
    },

    onTagClick: function(evt) {
      const el = evt.currentTarget;

      document.dispatchEvent(new Event('filter:selected'));

      // Do not ajax-load collection links
      if (el.classList.contains('no-ajax')) {
        return;
      }

      evt.preventDefault();
      if (isAnimating) {
        return;
      }

      isAnimating = true;

      const parent = el.parentNode;
      const newUrl = new URL(el.href);

      this.renderActiveTag(parent, el);
      this.updateScroll(true);
      this.startLoading();
      this.renderCollectionPage(newUrl.searchParams);
    },

    onFormSubmit: function(evt) {
      const el = evt.target;

      document.dispatchEvent(new Event('filter:selected'));

      // Do not ajax-load collection links
      if (el.classList.contains('no-ajax')) {
        return;
      }

      evt.preventDefault();
      if (isAnimating) {
        return;
      }

      isAnimating = true;

      const parent = el.closest('li');
      const formEl = el.closest('form');
      const formData = new FormData(formEl);

      this.renderActiveTag(parent, el);
      this.updateScroll(true);
      this.startLoading();
      this.renderFromFormData(formData);
    },

    onReplaceAjaxContent: function(newDom, section) {
      const openCollapsibleIds = this.fetchOpenCollasibleFilters();

      openCollapsibleIds.forEach(selector => {
        newDom
          .querySelectorAll(`[data-collapsible-id=${selector}]`)
          .forEach(this.openCollapsible);
      });

      var newContentEl = newDom.getElementById(section.nodeId);
      if (!newContentEl) {
        return;
      }

      document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;

      // Update references to new product count in collection
      var page = document.getElementById(section.nodeId);
      var countEl = page.querySelector('.collection-filter__item--count');
      if (countEl) {
        var count = countEl.innerText;
        if(count) {
          // count = JSON.parse(count);
          document.querySelectorAll('[data-collection-count]').forEach(el => {
            el.innerText = count.length + ' products';
          });
        }
      }

    },

    renderFromFormData: function(formData) {
      const searchParams = new URLSearchParams(formData);
      this.renderCollectionPage(searchParams);
    },

    renderCollectionPage: function(searchParams, updateURLHash = true) {
      this.ajaxRenderer
        .renderPage(window.location.pathname, searchParams, updateURLHash)
        .then(() => {
          theme.sections.reinit('collection-template');
          this.updateScroll(false);
          this.initPriceRange();
          theme.reinitProductGridItem();

          document.dispatchEvent(new CustomEvent('collection:reloaded'));

          isAnimating = false;
        });
    },

    updateScroll: function(animate) {
      var scrollTo = document.getElementById('CollectionAjaxContent').offsetTop;

      // Scroll below the sticky header
      if (theme.config.stickyHeader) {
        scrollTo = scrollTo - document.querySelector('#SiteHeader').offsetHeight;
      }

      if (!theme.config.bpSmall) {
        scrollTo -= 10;
      }

      if (animate) {
        window.scrollTo({top: scrollTo, behavior: 'smooth'});
      } else {
        window.scrollTo({top: scrollTo});
      }
    },

    bindBackButton: function() {
      // Ajax page on back button
      window.off('popstate' + this.namespace);
      window.on('popstate' + this.namespace, function(state) {
        if (state) {
          const newUrl = new URL(window.location.href);
          this.renderCollectionPage(newUrl.searchParams, false);
        }
      }.bind(this));
    },

    fetchOpenCollasibleFilters: function() {
      const openDesktopCollapsible = Array.from(
        document.querySelectorAll(
          `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`
        )
      );

      const openMobileCollapsible = Array.from(
        document.querySelectorAll(
          `${selectors.inlineWrapper} ${selectors.trigger}.${classes.isOpen}`
        )
      );

      return [
        ...openDesktopCollapsible,
        ...openMobileCollapsible,
      ].map(trigger => trigger.dataset.collapsibleId);
    },

    openCollapsible: function(el) {
      if (el.classList.contains(classes.collapsibleContent)) {
        el.style.height = 'auto';
      }

      el.classList.add(classes.isOpen);
    },

    /*============================================================================
      Misc collection page helpers
    ==============================================================================*/
    setFilterStickyPosition: function() {
      var headerHeight = document.querySelector('.site-header').offsetHeight - 1;
      document.querySelector(selectors.filterBar).style.top = headerHeight + 'px';

      // Also update top position of sticky sidebar
      var stickySidebar = document.querySelector('.grid__item--sidebar');
      if (stickySidebar) {
        stickySidebar.style.top = headerHeight + 30 + 'px';
      }
    },

    startLoading: function() {
      document.querySelector(selectors.collectionGrid).classList.add('unload');
    },

    forceReload: function() {
      this.init(this.container);
    },
  });

  return Collection;
})();

$(document).ready(function() {
  theme.sections = new theme.Sections();
  theme.sections.register('vendor-products', theme.VendorProducts);
  theme.sections.register('collection-header', theme.CollectionHeader);
  theme.sections.register('collection-template', theme.Collection);
  theme.sections.register("past-products", theme.PastProducts);
});